import {Likers, TYPE_COMMENT_LIKE} from "./likers";
import {UserInfo} from "../../../../core/auth";
import {MODAL_REVIEW_COMMENT_EDIT} from "../../../../core/modals";
import {highlightUrls} from "core/utils/url";
import {siteUrl} from "core/utils/url";
import {Notifier} from "core/widgets/notifier";

export class ReviewComment {
    /** @var {ReviewItem} */
    _parent = null;

	constructor(data) {
		this._data = data;
		this._parent = data.parent;
		this._author = (data.author instanceof UserInfo) ? data.author : new UserInfo(data.author);

		this._data.best = ko.observable(this._data.best);
		this._data.text = ko.observable(this._data.text);
		this._data.date_human = ko.observable(this._data.date_human);
        this._likers = new Likers(this.id, data.likes, data.my_like, TYPE_COMMENT_LIKE);

        this.collapsed = ko.observable(true);
		this.displayHtml = ko.pureComputed(() => highlightUrls(this._data.text()));
	}

	/** @return {int} */
	get id() {
		return this._data.id;
	}

	/** @return {UserInfo} */
	get author() {
		return this._author;
	}

	/** @return {string} Date in format Y-m-d H:i:s */
	get date() {
		return this._data.date;
	}

    /** @return {bool} Relative date */
    get best() {
        return this._data.best;
    }

	/** @return {string} Relative date */
	get date_human() {
		return this._data.date_human;
	}

	/** @return {bool} */
	get is_editable() {
		return this._data.is_editable;
	}

    /** @return {Likers} */
    get likers() {
        return this._likers;
    }

    expand() {
        this.collapsed(false);
    }

	remove() {
		if(confirm('Вы действительно хотите удалить комментарий?')) {
			this._parent.deleteComment(this);
		}
	}

	edit() {
        MODAL_REVIEW_COMMENT_EDIT.show(this.id, response => {
        	if(response && response.success) {
                this._data.text(response.text);
                if(response.date) {
                    this._data.date = response.date;
                    this._data.date_human(response.date_human);
                }
			}
		});
	}

	markAsBest() {
    	$.post(siteUrl('reviews/mark_comment_as_best'), {id: this.id}, null, 'json')
			.done(response => {
				if(response.success) {
					this._parent.comments.forEach(comment => comment.best(false));
					this.best(true);
					Notifier.success('Ответ отмечен как лучший');
				} else {
					Notifier.error();
				}
			})
			.fail(Notifier.errorXHR);
	}
}



// WEBPACK FOOTER //
// ./modules/reviews/common/model/reviewcomment.js